import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { WhatIsIncludedSection } from './components/WhatIsIncludedSection';
import { BonusSection } from './components/BonusSection';
import { PremiumBonusSection } from './components/PremiumBonusSection';
import { ImagineSection } from './components/ImagineSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PlanSelectionSection } from './components/PlanSelectionSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-[#0B1A2E] text-slate-200 font-sans selection:bg-blue-500/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <BeforeAfterSection data-id="element-5" />
        <WhatIsIncludedSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PremiumBonusSection data-id="element-8" />
        <ImagineSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />

        <PlanSelectionSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <SocialProofPopup data-id="element-14" />
      <MetaPixel data-id="element-15" />
    </div>;
}